import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
const CHECKOUT_STANDARD = 'https://profelisto.com.ar/checkouts/cn/hWNCOaSJE7otUOoTtN35qv6Q/es-ar?_r=AQABWd7vJL-OjcTRtS-AK8ijDDJ4ZGabub_-Vdhjn4tuR-c';
const CHECKOUT_ELITE = 'https://profelisto.com.ar/checkouts/cn/hWNCOaUzod0ZMOWRh0mUK5bu/es-ar?_r=AQABcwAg0WKh_x_0uzXShYV5MUl-G4cgn1N2t2DXeOjlKL0';
import { trackInitiateCheckout } from '../lib/pixel';
export function FinalCTA() {
  const handleStandardClick = () => {
    trackInitiateCheckout({
      value: 18990,
      currency: 'ARS',
      content_name: 'Portugués 360 — Pack Completo'
    });
  };
  const handleEliteClick = () => {
    trackInitiateCheckout({
      value: 27990,
      currency: 'ARS',
      content_name: 'Portugués 360 Elite'
    });
  };
  return <section className="w-full bg-deep-green py-20 px-4" data-id="element-111">
      <div className="max-w-3xl mx-auto text-center" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-113">
          <h2 className="text-xl md:text-2xl font-bold text-white mb-6" data-id="element-114">
            ⏰ El precio de lanzamiento cierra el viernes a las 23:59:
          </h2>
          <CountdownTimer data-id="element-115" />
          <p className="text-gold font-bold text-lg mt-6" data-id="element-116">
            Después sube $10.000 ARS y no vuelve.
          </p>
        </motion.div>

        <div className="space-y-6 max-w-md mx-auto mb-12" data-id="element-117">
          {/* CARD 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl p-6 shadow-lg border-2 border-transparent" data-id="element-118">
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-119">
              <span className="text-2xl" data-id="element-120">📘</span>
              <h3 className="text-xl font-bold text-deep-green" data-id="element-121">
                PORTUGUÉS 360 — Pack Completo
              </h3>
            </div>
            <p className="text-gray-500 text-sm mb-4" data-id="element-122">12 Tomos + 6 Bonus</p>
            <div className="text-deep-green font-extrabold text-3xl mb-6" data-id="element-123">
              $18.990 ARS
            </div>
            <a href={CHECKOUT_STANDARD} onClick={handleStandardClick} className="block w-full bg-white border-2 border-deep-green text-deep-green hover:bg-green-50 font-bold py-3 px-4 rounded-lg transition-colors" data-id="element-124">
              → QUIERO MIS 12 TOMOS + 6 BONUS
            </a>
          </motion.div>

          {/* CARD 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-xl p-6 shadow-xl border-2 border-gold transform scale-105" data-id="element-125">
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-126">
              <span className="text-2xl" data-id="element-127">🏆</span>
              <h3 className="text-xl font-bold text-deep-green" data-id="element-128">
                PORTUGUÉS 360 ELITE ⭐
              </h3>
            </div>
            <p className="text-gray-500 text-sm mb-4" data-id="element-129">
              12 Tomos + 6 Bonus + 2 Ebooks Elite
            </p>
            <div className="text-gold font-extrabold text-4xl mb-6" data-id="element-130">
              $27.990 ARS
            </div>
            <a href={CHECKOUT_ELITE} onClick={handleEliteClick} className="block w-full bg-gold hover:bg-yellow-500 text-deep-green font-extrabold py-4 px-4 rounded-lg shadow-md transition-colors text-center" data-id="element-131">
              → SÍ, QUIERO EL PACK ELITE
            </a>
          </motion.div>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-xs text-white/80 font-medium" data-id="element-132">
          <div className="flex items-center gap-1.5" data-id="element-133">
            <Lock size={14} data-id="element-134" />
            <span data-id="element-135">Pago 100% seguro</span>
          </div>
          <span className="hidden sm:inline text-white/30" data-id="element-136">|</span>
          <div className="flex items-center gap-1.5" data-id="element-137">
            <Zap size={14} data-id="element-138" />
            <span data-id="element-139">Acceso en 5 minutos</span>
          </div>
          <span className="hidden sm:inline text-white/30" data-id="element-140">|</span>
          <div className="flex items-center gap-1.5" data-id="element-141">
            <ShieldCheck size={14} data-id="element-142" />
            <span data-id="element-143">Garantía 7 días sin preguntas</span>
          </div>
          <span className="hidden sm:inline text-white/30" data-id="element-144">|</span>
          <div className="flex items-center gap-1.5" data-id="element-145">
            <CreditCard size={14} data-id="element-146" />
            <span data-id="element-147">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}